import toast from "react-hot-toast";

class Alert {
	static success(message: string) {
		toast.success(message, {
			duration: 5000,
			position: "bottom-center",
			style: {
				background: "#22c55e",
				color: "#fff"
			},
			iconTheme: {
				primary: "#fff",
				secondary: "#22c55e"
			}
		});
	}

	static error(message: string) {
		toast.error(message, {
			duration: 5000,
			position: "bottom-center",
			style: {
				background: "#ef4444",
				color: "#fff"
			},
			iconTheme: {
				primary: "#fff",
				secondary: "#ef4444"
			}
		});
	}

	static info(message: string) {
		toast(message, {
			duration: 5000,
			position: "bottom-center",
			icon: "i",
			style: {
				background: "#3b82f6",
				color: "#fff"
			}
		});
	}

	static warn(message: string) {
		toast(message, {
			duration: 5000,
			position: "bottom-center",
			icon: "!",
			style: {
				background: "#eab308",
				color: "#fff"
			}
		});
	}
}

export default Alert;
